var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "payment-info-box" }, [
    _vm.showTrialSection
      ? _c("div", { staticClass: "payment-text-area" }, [
          _c("div", { staticClass: "payment-top-area" }, [
            _c("div", { staticClass: "payment-duration-info" }, [
              _c("strong", { staticClass: "payment-title" }, [
                _vm._v("Free Trial"),
              ]),
              _c("span", { staticClass: "payment-duration" }, [
                _vm._v("$0/month"),
              ]),
              _c("span", { staticClass: "payment-date" }, [
                _vm._v(_vm._s(_vm.freeTrialExpiry)),
              ]),
            ]),
            _c(
              "a",
              {
                staticClass:
                  "flex items-center border relative max-w-full button-ui rounded-3xl border-transparent text-white bg-emphasizeblue hover:bg-emphasizeblue focus:outline-none focus:border-blue-500 focus:shadow-outline-blue active:bg-blue-500 px-3.5 py-2 text-sm leading-4 justify-center bg-secondary-100",
                attrs: { href: "#subscription", size: "sm", variant: "blue" },
              },
              [_vm._v(" Upgrade ")]
            ),
          ]),
          _c("p", [
            _vm._v(
              " The Free trial allows you to add unlimited resources to your Talent Directory. Please upgrade to start adding managers to your team. "
            ),
          ]),
        ])
      : _c("div", { staticClass: "payment-text-area" }, [
          _c("div", { staticClass: "payment-top-area" }, [
            _c("div", { staticClass: "payment-duration-info" }, [
              _c("strong", { staticClass: "payment-title" }, [
                _vm._v(_vm._s(_vm.subscriptionPlan + " Plan")),
              ]),
              _c("span", { staticClass: "payment-duration" }, [
                _vm._v(
                  "$" +
                    _vm._s(
                      Number(_vm.subcription?.subscription_plan?.price) / 100
                    ) +
                    "/month"
                ),
              ]),
            ]),
            !_vm.isalreadyPremium
              ? _c(
                  "a",
                  {
                    staticClass:
                      "flex items-center border relative max-w-full button-ui rounded-3xl border-transparent text-white bg-emphasizeblue hover:bg-emphasizeblue focus:outline-none focus:border-blue-500 focus:shadow-outline-blue active:bg-blue-500 px-3.5 py-2 text-sm leading-4 justify-center bg-secondary-100",
                    attrs: {
                      href: "#subscription",
                      size: "sm",
                      variant: "blue",
                    },
                  },
                  [_vm._v(" Upgrade ")]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center border disabledButton relative text-gray-800 max-w-full button-ui rounded-3xl border-transparent text-white bg-gray-300 px-3.5 py-2 text-sm leading-4 justify-center",
                    attrs: { href: "#", size: "sm", variant: "blue" },
                  },
                  [_vm._v(" Upgrade ")]
                ),
          ]),
          _c("p", [_vm._v(" " + _vm._s(_vm.getSlogan) + " ")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }